import { makeStyles, useTheme } from '@material-ui/core/styles';

export const Theme = useTheme;

export const useStyles = makeStyles(theme => {
	return {
		showroomGrid: {
			maxWidth: '100%',
			margin: '3.33% 3.5% 3.33% 3.5%',
			overflowX: 'hidden'
		},
		edgeToEdge: {
			marginLeft: 0,
			marginRight: 0
		},
		showroomContentSectionLoading: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			height: '100%'
		}
	};
});
